import { Component } from '@angular/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { Platform } from '@ionic/angular';
import { UnifiedLoginStorageService, UnifiedLoginService, CapacitorHttpService } from '@monorepo/services';
import { THeaderResponse } from '@monorepo/types';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IAppState, selectIsHeaderLoading } from './state';
import { HeaderFacade } from './state/header/header.facade';
import { TranslateService } from '@ngx-translate/core';
import { LOCAL_STORAGE_UTILS } from '@monorepo/utils';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public isHeaderLoading$: Observable<THeaderResponse['isLoading']>;

  constructor(
    private platformSvc: Platform,
    private store: Store<IAppState>,
    private translate: TranslateService,
    private capacitorHttpService: CapacitorHttpService,
    unifiedLoginService: UnifiedLoginService,
  ) {
    this.isHeaderLoading$ = this.store.pipe(select(selectIsHeaderLoading));
    this.initializeLocale();

    //For React App
    window.getUserDetails = () => unifiedLoginService.getUserInfo();

    this.platformSvc.ready().then(async () => {
      await SplashScreen.hide();
    });
  }

  async initializeLocale() {
    const locale = LOCAL_STORAGE_UTILS.retrieveData('locale');
    if (locale) {
      this.translate.setDefaultLang(locale);
      const cookieVal = await this.capacitorHttpService.getCookie('locale');
      if (locale !== cookieVal) {
        this.capacitorHttpService.setCookie({ key: 'locale', value: locale });
      }
    } else {
      this.translate.setDefaultLang('en');
      LOCAL_STORAGE_UTILS.storeData('locale', 'en');
      this.capacitorHttpService.setCookie({ key: 'locale', value: 'en' });
    }
  }
}
